import styled, { css } from "styled-components";
import { gray_footer_text, narrowScreenMediaQuery } from "../constants/styles";
import { FooterTheme } from "./theme_color";
import Section, { SectionSeparator } from "./Section";
import ExternalLink from "./ExternalLink";
import { unmodule } from "../util";

const UnnamedComponent = (props) => {
  return (
    <FooterTheme>
      <SectionSeparator />
      <Section $paddingY>
        <Flex>
          <div>
            <InfoTitle>Office Location</InfoTitle>
            <InfoDescP>
              <InfoIcon
                src={unmodule(require("../images/icons/icon-pin-footer.svg"))}
              />
              <div>
                Sudirman Park Commercial Area - (C12, B5, B8)
                <br />
                Jl. KH. Mas Mansyur No. 12 Central Jakarta City,
                <br />
                Jakarta 10250
              </div>
            </InfoDescP>
            <InfoDescP>
              <InfoIcon
                src={unmodule(require("../images/icons/icon-email-footer.svg"))}
              />
              <div>bd@taxsam.co</div>
            </InfoDescP>
            <Socials>
              <MenuLink to="https://www.facebook.com/taxsam.co">
                <img
                  src={unmodule(require("../images/icons/facebook.svg"))}
                  alt="facebook"
                />
              </MenuLink>
              <MenuLink to="https://linkedin.com/company/taxsam-co">
                <img
                  src={unmodule(require("../images/icons/linkedin.svg"))}
                  alt="linkedin"
                />
              </MenuLink>
              <MenuLink to="https://www.instagram.com/taxsam_co/">
                <img
                  src={unmodule(require("../images/icons/instagram.svg"))}
                  alt="instagram"
                />
              </MenuLink>
              <MenuLink to="https://www.youtube.com/@TAXSAMCO">
                <img
                  src={unmodule(require("../images/icons/youtube.svg"))}
                  alt="youtube"
                />
              </MenuLink>
              <MenuLink to="https://wa.me/+6282124457963">
                <img
                  src={unmodule(require("../images/icons/whatsapp.svg"))}
                  alt="whatsapp"
                />
              </MenuLink>
            </Socials>
            <CertifiedBy>
              Certified By :
              <div>
                <img
                  src={unmodule(
                    require("../images/tlc-certified-by-aptika.png"),
                  )}
                  alt="tlc certified by ditjen tata kelola aptika"
                />
              </div>
            </CertifiedBy>
          </div>
          <div>
            <InfoTitle>Resources</InfoTitle>
            <InfoDesc>
              <MenuLink to="https://taxbase.taxsam.co/jenis-peraturan-pajak/pajak-pusat/">
                Peraturan Pajak
              </MenuLink>
              <MenuLink to="/courses">Video Belajar Pajak</MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/library/workbook">
                Perpustakaan
              </MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/">
                Database Perpajakan
              </MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/insight-explore">
                Berita &amp; Artikel
              </MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/informasi/kurs-pajak">
                Informasi
              </MenuLink>
              <MenuLink to="/talks">Taxsam Talk</MenuLink>
              <MenuLink to="/affiliators">Affiliate Program</MenuLink>
            </InfoDesc>
          </div>
          <div>
            <InfoTitle>Product</InfoTitle>
            <InfoDesc>
              <MenuLink to="https://learning.taxsam.co/">
                Taxsam Learning Center
              </MenuLink>
              <MenuLink to="https://learning.taxsam.co/">
                Business Learning Center
              </MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/">Taxbase</MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/taxam-opini/opini-taxsam-co/">
                Taxsam Opinion
              </MenuLink>
              <MenuLink to="https://taxbase.taxsam.co/insight-explore/">
                Insight
              </MenuLink>
            </InfoDesc>
          </div>
          <LogoAndMonitoredByLogosDiv>
            <LogoDiv>
              <img
                src={unmodule(require("../images/taxsam-logo.png"))}
                alt="logo tlc"
              />
            </LogoDiv>
            <RegisteredAndMonitoredByTitle>
              Terdaftar dan Diawasi oleh
            </RegisteredAndMonitoredByTitle>
            <MonitoredByLogos>
              <MonitoredByLogo
                src={unmodule(require("../images/logo-kemnaker.png"))}
                alt="logo kementerian ketenagakerjaan"
              />
              <MonitoredByLogo
                src={unmodule(require("../images/logo-kemdikbud.png"))}
                alt="logo kementerian pendidikan dan kebudayaan"
              />
              <MonitoredByLogo
                src={unmodule(require("../images/logo-bea-cukai.png"))}
                alt="logo direktorat jenderal bea dan cukai"
              />
              <MonitoredByLogo
                src={unmodule(require("../images/logo-kemkeu.png"))}
                alt="logo kementerian keuangan"
              />
              <MonitoredByLogo
                src={unmodule(require("../images/logo-djp.png"))}
                alt="logo direktorat jenderal pajak"
              />
              <MonitoredByLogo
                src={unmodule(require("../images/logo-kominfo.png"))}
                alt="logo kementerian komunikasi dan informasi"
              />
            </MonitoredByLogos>
          </LogoAndMonitoredByLogosDiv>
        </Flex>
        <Copyrights>© 2025 Taxsam.co All Rights Reserved</Copyrights>
      </Section>
    </FooterTheme>
  );
};
export default UnnamedComponent;

const Socials = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 24px;

  & img {
    width: 40px;
    height: 40px;
  }
`;

const MenuLink = styled(ExternalLink)`
  color: ${gray_footer_text};
  display: block;
  text-decoration: unset;
`;

const CertifiedBy = styled.div`
  font-weight: bold;
  margin-top: 48px;

  & img {
    margin-top: 10px;
    width: 200px;
  }
`;

const InfoDesc = styled.div`
  line-height: 2;
`;

const InfoDescP = styled(InfoDesc)`
  display: flex;
  gap: 10px;
  line-height: normal;
  margin-bottom: 16px;
`;

const InfoTitle = styled.div`
  background-clip: text;
  background: linear-gradient(to right, #d85907, #f7b30c);
  display: inline-block;
  font-weight: bold;
  margin-bottom: 30px;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const cssCommonNarrow = css`
  @media ${narrowScreenMediaQuery} {
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    width: 305px;
  }
`;

const LogoDiv = styled.div`
  ${cssCommonNarrow};
  text-align: center;

  & > img {
    max-width: 250px;
    width: 100%;
  }
`;

const Flex = styled.div`
  ${cssCommonNarrow};
  align-items: start;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-top: 30px;
`;

const Copyrights = styled.div`
  ${cssCommonNarrow};
  margin-top: 50px;
  text-align: center;
`;

const InfoIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;

const RegisteredAndMonitoredByTitle = styled.div`
  font-weight: 700;
  text-align: center;
  margin: 18px 0;
`;

const MonitoredByLogos = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
`;

const MonitoredByLogo = styled.img`
  width: 100px;
  height: 100px;
`;

const LogoAndMonitoredByLogosDiv = styled.div`
  max-width: 350px;
`;
